import { TruncatedText } from "@carbon6/c6-frontend-design";
import { StatusChip } from "@/shared/ui/status";
import { formatDateTime } from "@/shared/utils/datetime/format";
import { formatSourceKind } from "../feature/datasetFormatters";
import type { DatasetTableRow } from "./DatasetTableRow";
import { LatestProbeChip } from "./components/LatestProbeChip";
import styles from "./datasetColumns.module.css";
import type { DataTableColumn } from "@carbon6/c6-frontend-design";

/**
 * Datasets 목록의 컬럼.
 *
 * 폭은 고정 px 이 아니라 `minmax` 로 둔다 — 이름과 주소가 화면 폭을 나눠 갖고, 좁은 창에서도
 * 종류 · 등록 시각이 잘리지 않는다. 긴 값은 `TruncatedText` 가 줄이고 전체는 툴팁이 갖는다.
 */
export const datasetColumns: readonly DataTableColumn<DatasetTableRow>[] = [
  {
    key: "displayName",
    header: "이름",
    width: "minmax(12rem, 2fr)",
    sortable: "both",
    render: (row) => (
      <span className={styles.nameCell}>
        <TruncatedText>{row.displayName}</TruncatedText>
        {row.isHidden ? <StatusChip tone="muted">숨김</StatusChip> : null}
      </span>
    ),
  },
  {
    key: "sourceRef",
    header: "원본 주소",
    width: "minmax(16rem, 3fr)",
    sortable: "both",
    render: (row) => <TruncatedText className={styles.sourceCell}>{row.sourceRef}</TruncatedText>,
  },
  {
    key: "sourceKind",
    header: "종류",
    width: "8rem",
    sortable: "both",
    render: (row) => formatSourceKind(row.sourceKind),
  },
  {
    key: "latestProbe",
    header: "Probe",
    width: "8rem",
    sortable: "both",
    render: (row) => <LatestProbeChip probe={row.latestProbe} />,
  },
  {
    key: "createdAtMs",
    header: "등록 시각",
    width: "11rem",
    sortable: "both",
    render: (row) => formatDateTime(row.createdAtMs),
  },
];

/** 초기 정렬 — 최근에 등록한 것이 위다. */
export const datasetInitialSort = { columnKey: "createdAtMs", direction: "desc" } as const;
